document.addEventListener("DOMContentLoaded", () => {
  const framePoint = document.querySelector(".charm-points");
  const charmProdsOpenbtn = document.getElementById("collapaddcharmsbtn");
  const charmProds = document.getElementById("add-charms_prodslist");
  const charmprodselected = document.querySelectorAll(".charm_product_selected");
  const productSlots = document.querySelectorAll(".charm_point");
  const addToCartbtn = document.querySelectorAll(".add_to_cart_main");
  const bundleForm = document.querySelector("#products-bundle-charm");

  let selected_product = null;

  charmProdsOpenbtn.addEventListener("click", () => {
    charmProds.classList.toggle("products-visible");
    charmProdsOpenbtn.classList.toggle("collap-opened");
    charmprodselected.forEach(prod => prod.classList.remove("selected-product"));
  });

  bundleForm.addEventListener("submit", async (e) => {
    e.preventDefault();

    // const allFilled = Array.from(productSlots).every(item =>
    //   item.querySelector(".selected__product_appended")
    // );

    // if (!allFilled) {
    //   alert("Please select a product for each slot before adding to cart.");
    //   return;
    // }

    const formData = new FormData(bundleForm);

    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Accept": "application/json"
        },
        body: formData
      });

      if (!response.ok) throw new Error("Failed to add items to cart");

      const data = await response.json();

      const msgEl = bundleForm.querySelector(".product-added-to-cart-msg");
      msgEl.innerText = "Your items have been added to the cart!";

      setTimeout(() => {
        msgEl.innerText = "";
      }, 3000);
      setTimeout(() => document.querySelector(".js-mini-cart-trigger").click(),300);
    } catch (error) {
      console.error("Error adding bundle to cart:", error);
      alert("There was a problem adding your items to the cart. Please try again.");
    }
  });
  
  document.addEventListener("click", (e) => {
    const prodCard = e.target.closest(".charm_product_card");
    const addBtn = e.target.closest(".prod_addto_holder_btn");
    
    if(e.target.closest(".selected_productClose")){
      charmprodselected.forEach(prod => prod.classList.remove("selected-product"));
      charmProds.classList.toggle("products-visible");
      charmProdsOpenbtn.classList.toggle("collap-opened");
    }

    if (prodCard) {
      const clickedProductId = prodCard.getAttribute("product-id");

      charmprodselected.forEach(selProd => {
        const isSameProduct = selProd.getAttribute("product-id") === clickedProductId;
        selProd.classList.toggle("selected-product", isSameProduct);
      });

      charmProds.classList.remove("products-visible");
      charmProdsOpenbtn.classList.remove("collap-opened");
      selected_product = Array.from(charmprodselected).find(p => p.classList.contains("selected-product"));


      let thumbnailSwiper = selected_product?.querySelector(".product_thumbnail_images");
      let mainSwiper = selected_product?.querySelector(".main_images_swiper");
    var thumbs_swiper = new Swiper(thumbnailSwiper, {
      spaceBetween: 10,
      slidesPerView: 3,
      watchSlidesProgress: true,
    })

    var main__swiper = new Swiper(mainSwiper, {
      spaceBetween: 1,
      slidesPerView:1,
      thumbs: {
        swiper: thumbs_swiper,
      }
    })
      return;
    }

    if (addBtn && selected_product && addBtn.closest(".charm_product_selected")) {
      const productVariants = selected_product.querySelectorAll("input[type=radio]");
      const checkedVariant = selected_product.querySelector("input[type=radio]:checked");

      let variantImg = checkedVariant?.getAttribute("data-image") ?? addBtn.getAttribute("data-image");
      const prodVariantId = checkedVariant?.getAttribute("variant-id") ?? addBtn.getAttribute("variant-id");

      const hasVariants = productVariants.length > 0;
      const hasCheckedVariant = Array.from(productVariants).some(v => v.checked);

      const error = document.createElement("div");
      error.className = "selection__error";
      if (!selected_product.querySelector(".selection__error")) {
        selected_product.querySelector(".charm_prod_content").appendChild(error);
      }

      if (hasVariants && !hasCheckedVariant) {
        selected_product.querySelector(".selection__error").innerHTML = "Please select a variant first!";
        return;
      } else {
        const existingError = selected_product.querySelector(".selection__error");
        if (existingError) existingError.innerHTML = "";
      }
      const selected_charm = framePoint.querySelector(".charm_point.selected");
      let slotno = selected_charm.querySelector(".charm_point_num").innerText;
      if (variantImg == "empty") {
        variantImg = selected_product.querySelector("img")?.src;
      } else {
        variantImg = variantImg;
      }

      const appended_child = document.createElement("div");
      appended_child.setAttribute("variant-id", prodVariantId);
      appended_child.className = "selected__product_appended";
      appended_child.innerHTML = `<input type="hidden" name="items[${slotno - 1}][id]" value="${prodVariantId}" form="products-bundle-charm"><input class="product_slot_no" type="hidden" name="items[${slotno - 1}][properties][Slot no]" value="${slotno}" form="products-bundle-charm"><img src="${variantImg}" width="auto" height="auto" alt="charm__product">`;

      if (!selected_charm) {
        document.querySelector(".selection__error").innerHTML = "Please select a charm position first!";
        return;
      }
      document.querySelector(".selection__error").innerHTML = "";
      if(!selected_charm.querySelector(".selected__product_appended")){
        selected_charm.querySelector(".select_charm").remove();
        selected_charm.querySelector(".charm_popups").appendChild(appended_child);
        selected_charm.classList.add("selected__product")
        selected_charm.querySelector(".charm_settings").classList.add("show_cham_settings");
      }else{
        selected_charm.querySelector(".selected__product_appended").outerHTML = appended_child.outerHTML;
      }
    }
  });


  framePoint.addEventListener("click", (e) => {
    if (!e.target.closest(".charm_point")) {
      framePoint.querySelectorAll(".charm_point.selected").forEach(charm => {
        charm.classList.remove("selected");
        charm.querySelector(".charm_popups .select_charm")?.remove();
        charm.querySelector(".charm_settings").classList.remove("show_cham_settings");
      });
    }
    const clickedCharm = e.target.closest(".charm_point");
    if (!clickedCharm) return;
    
    framePoint.querySelectorAll(".charm_point").forEach(charm => {
      charm.classList.remove("selected");
      charm.querySelector(".charm_popups .select_charm")?.remove();
      charm.querySelector(".charm_settings").classList.remove("show_cham_settings");
    });
    
    clickedCharm.classList.add("selected");

    const charmPopups = clickedCharm.querySelector(".charm_popups");
    const newDiv = document.createElement("div");
    if (charmPopups && !charmPopups.querySelector(".select_charm")) {
      newDiv.classList.add("select_charm");
      newDiv.textContent = "Select a Charm to Attach";
      if(charmPopups.querySelector(".selected__product_appended")){
        charmPopups.querySelector(".charm_settings").classList.add("show_cham_settings");
      }else{
        charmPopups.appendChild(newDiv);
      }
    }
    
    if(e.target.closest(".charm_remove")){
      charmPopups.querySelector(".selected__product_appended").remove();
      charmPopups.appendChild(newDiv);
      charmPopups.querySelector(".charm_settings").classList.remove("show_cham_settings");
    }

    if(e.target.closest(".charm_move")){
      charmPopups.querySelector(".charm_move_select").classList.toggle("move_active");
    }
    if(e.target.closest(".slot_selection_close")){
      charmPopups.querySelector(".charm_move_select").classList.remove("move_active");
    }
    if (e.target.closest(".slot_select_aply_btn")) {
      const selectedSlotInput = document.querySelector(".charm_slot input:checked");
      if (!selectedSlotInput) return;

      const slots = framePoint.querySelectorAll(".charm_point");

      const sourceSlot = e.target.closest(".charm_point");
      if (!sourceSlot) return;

      const variantProduct = sourceSlot.querySelector(".selected__product_appended");
      if (!variantProduct) return;

      const destinationSlot = Array.from(slots).find(slot =>
        slot.getAttribute("data-point-position") === selectedSlotInput.getAttribute("slot-no")
      );
      if (!destinationSlot) return;

      const popup = destinationSlot.querySelector(".charm_popups");
      if (popup?.querySelector(".selected__product_appended")) {
        popup.querySelector(".selected__product_appended").remove();
      }

      variantProduct.querySelector(".product_slot_no")
        ?.setAttribute("value", selectedSlotInput.getAttribute("slot-no"));
      
      popup?.appendChild(variantProduct);

      slots.forEach(slot => {
        slot.classList.remove("selected__product", "selected");
        slot.querySelector(".charm_settings")?.classList.remove("show_cham_settings");
        slot.querySelector(".charm_move_select")?.classList.remove("move_active");
      });

      destinationSlot.classList.add("selected__product", "selected");
      destinationSlot.querySelector(".charm_settings")?.classList.add("show_cham_settings");
    }
  })
})
